export const theme = {
  colors: {
    primaryRed: '#b92232',
    background: '#1a1817',
    white: '#FFFFFF',
    lightGold: '#DFB673',
    black: '#000000',
    alfaLightGold: '#dfb67399',
    gcadOrange: '#FF8A22',
    gcadBlack: '#2E2E2E',
  },
  gradients: {
    gcad: 'linear-gradient(45.59deg, #FB7C2B 1.01%, #F54613 50.18%, #AC0023 100%);',
  },
  breakpoints: {},
}
